import React, { useState } from 'react';
import { Brand, CustomerType } from 'cpfr-common';
import { ContentSection, Icon, IconSize, Layout, PageWrap, Notification } from '@vwfs-bronson/bronson-react';
import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { useTranslation } from 'react-i18next';
import { currentBrand } from 'config';
import RegistrationContract from './contract/RegistrationContract';
import { RegistrationPhysical } from './physical-person';
import { RegistrationLegal } from './legal-person';
import { CustomerInformationWithContract } from './RegistrationFormDataTypes';

export const RegistrationUi: React.FC = () => {
    const { t } = useTranslation('registration');
    const [customer, setCustomer] = useState<CustomerInformationWithContract>();
    const isFS = currentBrand === Brand?.FSVG;

    const scrollDown = () => {
        setTimeout(() => window.scrollTo({ left: 0, top: 800, behavior: 'smooth' }), 500);
    };
    const renderForm = () => {
        if (customer && customer.customerType === CustomerType.Retail) {
            return <RegistrationPhysical customer={customer} isRetail />;
        }

        if (customer && [CustomerType.BIC, CustomerType.BA, CustomerType.BNC].includes(customer.customerType)) {
            return <RegistrationPhysical customer={customer} />;
        }

        if (customer && customer.customerType === CustomerType.PM) {
            return <RegistrationLegal contractNumber={customer.contractNumber} />;
        }
    };

    return (
        <>
            <ContentSection>
                <PageWrap size={'xsmall'}>
                    <Layout className={'u-mt-large'}>
                        <Layout.Item default={'1/1'} className={'u-text-center'}>
                            <h1>{t('registration-form.head.title')}</h1>
                            <p>{t('registration-form.head.info-identification')}</p>
                            <p>{t('registration-form.head.info-legal-identification')}</p>
                            <p>
                                <Icon
                                    name="exclamation-mark"
                                    size={IconSize.XSMALL}
                                    className="u-text-alert u-mr-xxxsmall"
                                />{' '}
                                {t('registration-form.head.info-fill-data')}
                            </p>
                            {isFS && (
                                <Notification
                                    className="u-text-left"
                                    status={NotificationStatus.info}
                                    testId="fs-infobox"
                                    title={''}
                                    hideTitle={true}
                                    visible
                                    showCloseButton={false}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: t('registration-form.person.fs-infobox.text'),
                                        }}
                                    />
                                </Notification>
                            )}
                        </Layout.Item>

                        <RegistrationContract
                            onSuccess={(c) => {
                                scrollDown();
                                setCustomer(c);
                            }}
                        />
                        {customer && renderForm()}
                    </Layout>
                </PageWrap>
            </ContentSection>
        </>
    );
};
